import type { LandingPage } from '@tipi/shared'

export type SeoKeywordLandingId = 'escandallo-sin-ordenador' | 'app-escandallos' | 'para-quien-es'

export type SeoKeywordLandingLayout = 'voice-escandallo' | 'app-timeline' | 'who-its-for'

export type SeoKeywordLandingDefinition = {
    id: SeoKeywordLandingId
    /** Locale-free ES public path. */
    path: string
    layout: SeoKeywordLandingLayout
    landingPage: LandingPage
}

/** Only ship landings that have a finished design handoff. */
export const SEO_KEYWORD_LANDINGS: readonly SeoKeywordLandingDefinition[] = [
    {
        id: 'escandallo-sin-ordenador',
        path: '/como-hacer-un-escandallo-sin-ordenador',
        layout: 'voice-escandallo',
        landingPage: 'escandallo-sin-ordenador',
    },
    {
        id: 'app-escandallos',
        path: '/app-escandallos',
        layout: 'app-timeline',
        landingPage: 'app-escandallos',
    },
    {
        id: 'para-quien-es',
        path: '/para-quien-es',
        layout: 'who-its-for',
        landingPage: 'para-quien-es',
    },
] as const

export const SEO_KEYWORD_LANDING_PATHS = SEO_KEYWORD_LANDINGS.map(landing => landing.path)

export function getSeoKeywordLandingByPath(path: string): SeoKeywordLandingDefinition | undefined {
    return SEO_KEYWORD_LANDINGS.find(landing => landing.path === path)
}

export function seoKeywordI18nPrefix(id: SeoKeywordLandingId): `seoKeyword.landings.${SeoKeywordLandingId}` {
    return `seoKeyword.landings.${id}`
}
